var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"st0","d":"M23.1,5.1c-0.8,0.4-1.7,0.6-2.6,0.7c0.9-0.6,1.7-1.5,2-2.5c-0.9,0.6-1.9,0.9-2.9,1.1c-0.8-0.9-2-1.5-3.3-1.5\n\t\tc-2.5,0-4.5,2-4.5,4.5c0,0.4,0,0.7,0.1,1C8,8.4,4.7,6.5,2.4,3.8C2,4.5,1.8,5.2,1.8,6.1c0,1.6,0.8,3,2,3.8c-0.7,0-1.5-0.2-2-0.6v0.1\n\t\tc0,2.2,1.6,4.1,3.6,4.5C5,13.9,4.7,14,4.2,14c-0.3,0-0.6,0-0.8-0.1c0.6,1.9,2.2,3.2,4.3,3.2c-1.6,1.2-3.5,1.9-5.7,1.9\n\t\tc-0.4,0-0.7,0-1.1-0.1c2,1.3,4.5,2,7.1,2c8.4,0,13-7,13-13c0-0.2,0-0.4,0-0.6C21.7,6.8,22.5,6.1,23.1,5.1L23.1,5.1z","key":0}),React.createElement("path",{"d":"M0,0h24v24H0V0z","fill":"none","key":1})]);
}

Icon.defaultProps = {"fill":"#1da1f2","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;
